module.exports = __webpack_public_path__ + "img/ico-search-result-btn.d2d1a7be.svg";